// Подсказки Зои в дневнике и карточка «Первые шаги».
//
// Решение владельца 26.10.2026: вместо копии интерфейса в фазе 1 онбординга —
// реплики Зои поверх настоящего дневника. Правила:
//   — одна подсказка на экране, следующая сразу после закрытия предыдущей;
//   — появляется по событию (request из экрана), не по таймеру;
//   — привязана к настоящему элементу по data-guide, стрелка к нему;
//   — ничего не затемняет, тап в любое место закрывает, действие закрывает само;
//   — каждая один раз на аккаунт, состояние на сервере (api/guide.js);
//   — только у аккаунтов варианта bubbles (safeUser.guide_variant), есть
//     выключатель в настройках дневника.
// Экран зовёт guide.request(key, { anchor, place }) там, где действие стало
// актуальным, и guide.done(key), когда человек его совершил. Пузырь рисует
// components/GuideBubble.vue, он один на приложение (App.vue).

import { reactive, computed, ref } from 'vue'
import api from './api.js'

// Тексты до 90 знаков, форма «ты/вы» из профиля. place — где пузырь
// относительно элемента; ok — показывать «Понятно», когда подсказку нечем
// закрыть действием.
export const HINTS = {
  first_add:    { ty: 'Сфотографируй первое блюдо или надиктуй, остальное посчитаю я',
                  vy: 'Сфотографируйте первое блюдо или надиктуйте, остальное посчитаю я' },
  add_ways:     { ty: 'Фото, голос или поиск по названию. Этикетку и штрихкод тоже читаю',
                  vy: 'Фото, голос или поиск по названию. Этикетку и штрихкод тоже читаю' },
  check_weight: { ty: 'Проверь вес: нажми на граммы и поправь, если на тарелке больше',
                  vy: 'Проверьте вес: нажмите на граммы и поправьте, если на тарелке больше' },
  dish_edit:    { ty: 'Нажми на блюдо, чтобы поправить вес, заменить продукт или удалить',
                  vy: 'Нажмите на блюдо, чтобы поправить вес, заменить продукт или удалить' },
  ai_estimate:  { ty: 'Это моя оценка. Фото этикетки сделает цифры точнее',
                  vy: 'Это моя оценка. Фото этикетки сделает цифры точнее' },
  hunger:       { ty: 'Отметь голод до и сытость после, я учту это в разборах',
                  vy: 'Отметьте голод до и сытость после, я учту это в разборах' },
  meal_time:    { ty: 'Время приёма можно поменять, нажми на него',
                  vy: 'Время приёма можно поменять, нажмите на него', ok: true },
  repeat:       { ty: 'То же, что вчера? Здесь повтор одним нажатием',
                  vy: 'То же, что вчера? Здесь повтор одним нажатием' },
  favorite:     { ty: 'Сердечко кладёт блюдо в Избранное, потом добавишь в два нажатия',
                  vy: 'Сердечко кладёт блюдо в Избранное, потом добавите в два нажатия' },
  week:         { ty: 'Здесь неделя целиком: средние по дням и что в норме',
                  vy: 'Здесь неделя целиком: средние по дням и что в норме', ok: true },
  ask_zoya:     { ty: 'Спроси меня о любом блюде или о своём дне, я вижу дневник',
                  vy: 'Спросите меня о любом блюде или о своём дне, я вижу дневник' },
  label_card:   { ty: 'Такого товара у меня нет. Сними этикетку, заведу карточку',
                  vy: 'Такого товара у меня нет. Снимите этикетку, заведу карточку' },
  norms:        { ty: 'Нормы пока средние. Расскажи о себе, и я посчитаю твои по росту, весу и возрасту',
                  vy: 'Нормы пока средние. Расскажите о себе, и я посчитаю ваши по росту, весу и возрасту',
                  cta: 'Рассказать о себе' },
  // Ключи старых событий пустых вкладок сохранены для истории.
  // С 02.11 Cooking и AddFoodDialog рисуют эти пояснения непосредственно
  // через ZoyaBubble у всех пользователей, независимо от онбординга.
  empty_fav:     { ty: 'Избранное пока пустое. Сердечко на фото блюда кладёт его сюда, потом добавишь в два нажатия',
                   vy: 'Избранное пока пустое. Сердечко на фото блюда кладёт его сюда, потом добавите в два нажатия', sticky: true },
  empty_recipes: { ty: 'Создавай рецепты на странице «Мои рецепты», а здесь добавляй блюда на их основе',
                   vy: 'Создавайте рецепты на странице «Мои рецепты», а здесь добавляйте блюда на их основе', sticky: true },
  empty_recent:  { ty: 'Здесь будут блюда и продукты, которые ты уже добавлял: повтор одним нажатием',
                   vy: 'Здесь будут блюда и продукты, которые вы уже добавляли: повтор одним нажатием', sticky: true },
  cook_fav:      { ty: 'Добавь первое блюдо в Избранное: нажми на сердечко на фото любого блюда',
                   vy: 'Добавьте первое блюдо в Избранное: нажмите на сердечко на фото любого блюда', sticky: true },
  cook_recipes:  { ty: 'Рецепт можно создать здесь или отредактировать блюдо из Избранного и сохранить как рецепт',
                   vy: 'Рецепт можно создать здесь или отредактировать блюдо из Избранного и сохранить как рецепт', sticky: true },
  // Вкладка «аналитика» (решение владельца 27.10.2026): подсказки по порядку
  // при первом открытии у всех вариантов онбординга, без кнопки «Понятно» —
  // только текст, закрываются тапом или сами; и две сменные инструкции
  // выбора дат на календаре — sticky и again при каждом выборе.
  an_range:      { ty: 'Период меняется здесь',
                   vy: 'Период меняется здесь', everyone: true },
  an_colors:     { ty: '{deficit} — дефицит, {surplus} — профицит, {maintenance} — норма ±10%. Без цвета — записей нет',
                   vy: '{deficit} — дефицит, {surplus} — профицит, {maintenance} — норма ±10%. Без цвета — записей нет', everyone: true },
  an_scroll:     { ty: 'График длиннее экрана: промотай его влево и вправо',
                   vy: 'График длиннее экрана: промотайте его влево и вправо', everyone: true },
  an_bar:        { ty: 'Нажмите на столбик для подробностей дня',
                   vy: 'Нажмите на столбик для подробностей дня', everyone: true },
  an_pick_start: { ty: 'Выбери дату начала', vy: 'Выберите дату начала', sticky: true, everyone: true },
  an_pick_end:   { ty: 'И дату окончания', vy: 'И дату окончания', sticky: true, everyone: true },
  // Экран Зои: пустые вкладки «Память обо мне» и «Текущий план». everyone —
  // у всех вариантов, не только bubbles: это замена подписи, а не онбординг
  memory_empty:  { ty: 'Пока я ничего не запомнила. Расскажи о себе в чате или напиши «запомни…», и это появится здесь',
                   vy: 'Пока я ничего не запомнила. Расскажите о себе в чате или напишите «запомни…», и это появится здесь', sticky: true, everyone: true },
  plan_empty:    { ty: 'Плана пока нет. Заполни профиль и попроси меня в чате составить план',
                   vy: 'Плана пока нет. Заполните профиль и попросите меня в чате составить план', sticky: true, everyone: true },
}

// Путь новичка — первые действия, по одному разу на аккаунт (воронка в
// админке, вкладка «Онбординг»). Пишутся у вариантов tutorial и bubbles,
// чтобы сравнивать их; у legacy — нет. Ключи — JOURNEY_KEYS в lib/guide.js.
export const JOURNEY_KEYS = [
  'j_diary', 'j_add', 'j_camera', 'j_voice', 'j_search', 'j_barcode', 'j_recent',
  'j_recognized', 'j_saved', 'j_edit', 'j_edit_saved', 'j_week', 'j_zoya', 'j_phase2', 'j_steps_go',
]

// Карточка «Первые шаги» живёт 7 дней с регистрации
export const CHECKLIST_DAYS = 7
export const CHECKLIST_ITEMS = ['photo', 'edit', 'repeat', 'week', 'profile']

const SHOW_DELAY_MS = 400
const AUTO_DISMISS_MS = 20000
const ANCHOR_RETRY_MS = 250
const ANCHOR_RETRIES = 8

export const state = reactive({
  loaded: false,
  userId: null,
  journey: {},        // { j_key: true } — что уже записано
  variant: 'legacy',
  off: false,
  hints: {},
  checklist: { closed: true, items: {} },
  has_entries: false,
  created_at: null,
})

// Что сейчас на экране: { key, text, anchor, place, ok }
export const active = ref(null)

export const enabled = computed(() => state.loaded && state.variant === 'bubbles' && !state.off)

export const checklistVisible = computed(() => {
  if (!enabled.value || state.checklist.closed) return false
  const items = state.checklist.items || {}
  if (CHECKLIST_ITEMS.every(k => items[k])) return false
  if (state.created_at && Date.now() - new Date(state.created_at).getTime() > CHECKLIST_DAYS * 864e5) return false
  return true
})

export const checklistDone = computed(() => CHECKLIST_ITEMS.filter(k => state.checklist.items?.[k]).length)

function cacheKey(userId) { return `zoya-guide:${userId}` }
function journeyKey(userId) { return `zoya-guide-j:${userId}` }

function applyState(data) {
  state.variant = data.variant || 'legacy'
  state.off = !!data.off
  state.hints = data.hints || {}
  state.checklist = data.checklist || { closed: true, items: {} }
  state.has_entries = !!data.has_entries
  state.created_at = data.created_at || null
  state.loaded = true
}

/** Состояние с сервера; пока оно едет — из localStorage, чтобы не мигать. */
export async function load(user) {
  if (!user?.id) { reset(); return }
  if (state.userId !== user.id) {
    reset()
    state.userId = user.id
    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey(user.id)) || 'null')
      if (cached) applyState(cached)
    } catch { /* без кэша */ }
    try { state.journey = JSON.parse(localStorage.getItem(journeyKey(user.id)) || '{}') || {} } catch { state.journey = {} }
  }
  // Вариант известен из профиля сразу: не bubbles — на сервер не ходим
  if (user.guide_variant && user.guide_variant !== 'bubbles') {
    applyState({ variant: user.guide_variant, off: true })
    return
  }
  try {
    if (queue.length) await flush()  // иначе ответ сервера затрёт только что записанное
    const { data } = await api.get('/guide/state')
    applyState(data)
    try { localStorage.setItem(cacheKey(user.id), JSON.stringify(data)) } catch { /* место кончилось */ }
  } catch { /* остаёмся на кэше или без подсказок */ }
}

export function reset() {
  state.loaded = false
  state.userId = null
  state.variant = 'legacy'
  state.off = false
  state.hints = {}
  state.checklist = { closed: true, items: {} }
  state.has_entries = false
  state.created_at = null
  state.journey = {}
  sessionDismissed.clear()
  clearPending()
  active.value = null
}

// ── события ──────────────────────────────────────────────
let queue = []
let flushTimer = null
function record(key, event, meta) {
  const now = new Date().toISOString()
  if (!key.startsWith('_') && !key.startsWith('j_')) {
    state.hints[key] = { ...(state.hints[key] || {}), [event]: now }
  }
  queue.push({ key, event, meta: meta || undefined })
  clearTimeout(flushTimer)
  flushTimer = setTimeout(flush, 500)
}
async function flush() {
  if (!queue.length) return
  const batch = queue.splice(0, 20)
  try { await api.post('/guide/events', { events: batch }) } catch { /* подсказки не стоят повтора */ }
  if (queue.length) flush()
}

function seen(key) {
  const h = state.hints[key]
  return !!(h && (h.shown || h.done || h.dismissed))
}

// ── показ ────────────────────────────────────────────────
let pending = null
let autoTimer = null
const sessionDismissed = new Set()   // закрытые sticky-подсказки — до перезапуска
function clearPending() {
  if (pending) { clearTimeout(pending.timer); pending = null }
  clearTimeout(autoTimer)
}

function resolveAnchor(anchor) {
  if (typeof anchor === 'function') return anchor()
  if (typeof anchor === 'string') return document.querySelector(anchor)
  return anchor || null
}

/**
 * Экран просит показать подсказку. Вернёт true, если она будет показана.
 * anchor — селектор ([data-guide="fab"]) или функция, дающая элемент;
 * place — 'above' | 'below' (по умолчанию выше элемента); again — показать,
 * даже если уже показывали (строка карточки «Первые шаги»).
 */
export function request(key, { anchor, place = 'above', meta, again = false, onCta = null, ready = null } = {}) {
  const hint = HINTS[key]
  if (!hint) return false
  const allowed = enabled.value || (hint.everyone && state.loaded)
  if (!allowed || (ready && !ready())) return false
  const sticky = !!hint.sticky
  if (sticky && sessionDismissed.has(key)) return false
  if ((seen(key) && !again && !sticky) || active.value || pending) return false
  let tries = 0
  const attempt = () => {
    pending = null
    if (!(enabled.value || (hint.everyone && state.loaded)) || active.value || (seen(key) && !again && !sticky)) return
    const el = resolveAnchor(anchor)
    if (!el || !el.isConnected) {
      if (tries++ < ANCHOR_RETRIES) pending = { key, timer: setTimeout(attempt, ANCHOR_RETRY_MS) }
      return
    }
    // The user may have scrolled during the show delay. Do not mark an unseen hint as shown.
    if (ready && !ready()) return
    const vy = JSON.parse(localStorage.getItem('zoya-user') || '{}')?.address_form === 'вы'
    active.value = { key, text: vy ? hint.vy : hint.ty, anchor, place, ok: !!hint.ok, cta: hint.cta || null, onCta, sticky }
    if (!sticky || !seen(key)) record(key, 'shown', meta)
    clearTimeout(autoTimer)
    if (!sticky) autoTimer = setTimeout(() => dismiss(key), AUTO_DISMISS_MS)
  }
  pending = { key, timer: setTimeout(attempt, SHOW_DELAY_MS) }
  return true
}

/** Человек закрыл подсказку тапом, «Понятно» или она истекла. */
export function dismiss(key) {
  if (pending && (!key || pending.key === key)) clearPending()
  if (!active.value || (key && active.value.key !== key)) return
  const k = active.value.key
  if (active.value.sticky) sessionDismissed.add(k)
  active.value = null
  clearTimeout(autoTimer)
  if (!state.hints[k]?.done && !state.hints[k]?.dismissed) record(k, 'dismissed')
}

/** Человек сделал то, о чём была подсказка — закрываем без «dismissed». */
export function done(key) {
  if (pending && pending.key === key) clearPending()
  if (active.value?.key === key) { active.value = null; clearTimeout(autoTimer) }
  if (!enabled.value || state.hints[key]?.done) return
  record(key, 'done')
}

/** Нажата кнопка действия в пузыре: закрываем как «сделано» и ведём, куда просил экран. */
export function cta() {
  const a = active.value
  if (!a) return
  active.value = null
  clearTimeout(autoTimer)
  if (!state.hints[a.key]?.done) record(a.key, 'done', { via: 'cta' })
  if (typeof a.onCta === 'function') a.onCta()
}

/** Правка блюда сохранена: пункт «Поправить вес или продукт» в «Первых шагах». */
export function editSaved() {
  journey('j_edit_saved')
  if (enabled.value && !state.checklist.items?.edit) state.checklist.items = { ...state.checklist.items, edit: true }
}

/** Шаг пути новичка — один раз на аккаунт, без показа. */
export function journey(key, meta) {
  if (!state.userId || !JOURNEY_KEYS.includes(key)) return
  if (state.variant === 'legacy' || state.journey[key]) return
  state.journey = { ...state.journey, [key]: true }
  try { localStorage.setItem(journeyKey(state.userId), JSON.stringify(state.journey)) } catch { /* место кончилось */ }
  record(key, 'hit', meta)
}

/** Экран с подсказкой закрылся (окно размонтировано): прячем без записи. */
export function hide(key) {
  if (pending && (!key || pending.key === key)) clearPending()
  if (active.value && (!key || active.value.key === key)) {
    active.value = null
    clearTimeout(autoTimer)
  }
}

/** Отметить вкладку «неделя» открытой для карточки «Первые шаги». */
export function markWeekSeen() {
  if (!enabled.value || state.hints.week?.shown) return
  record('week', 'shown', { via: 'tab' })
  state.checklist.items = { ...state.checklist.items, week: true }
}

// ── выключатель и карточка ───────────────────────────────
export function setOff(off) {
  state.off = !!off
  if (off) { clearPending(); active.value = null }
  record('_all', off ? 'off' : 'on')
}

export function closeChecklist() {
  state.checklist = { ...state.checklist, closed: true }
  record('_checklist', 'dismissed', { done: checklistDone.value })
}

export default { state, active, enabled, checklistVisible, checklistDone, load, reset, request, dismiss, done, cta, journey, editSaved, hide, markWeekSeen, setOff, closeChecklist, HINTS }
